import { useCallback, useState } from 'react';
import { getStudentRecord } from '../services/recordsService';

export function useStudentRecord() {
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [searched, setSearched] = useState(false);

  const search = useCallback(async (lrn, gradeLevel) => {
    setLoading(true);
    setError('');
    setSearched(true);
    try {
      const data = await getStudentRecord(lrn, gradeLevel);
      setRecord(data);
    } catch (err) {
      setError(err.message || 'Failed to look up record');
      setRecord(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setRecord(null);
    setError('');
    setSearched(false);
  }, []);

  return { record, loading, error, searched, search, reset };
}
